import { graphql } from '../graphql';

export const createSavedViewMutation = graphql(`
  mutation CreateSavedView($input: CreateSavedViewInput!) {
    createSavedView(input: $input) {
      id
      projectId
      name
      description
      visibility
      camera
      clipBox
      visibleLayerIds
      baseMapId
      isInitial
      createdById
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
    }
  }
`);

export const updateSavedViewMutation = graphql(`
  mutation UpdateSavedView($input: UpdateSavedViewInput!) {
    updateSavedView(input: $input) {
      id
      projectId
      name
      description
      visibility
      camera
      clipBox
      visibleLayerIds
      baseMapId
      isInitial
      createdById
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
    }
  }
`);

export const deleteSavedViewMutation = graphql(`
  mutation DeleteSavedView($id: ID!) {
    deleteSavedView(id: $id)
  }
`);

export const setInitialSavedViewMutation = graphql(`
  mutation SetInitialSavedView($id: ID!, $initial: Boolean!) {
    setInitialSavedView(id: $id, initial: $initial) {
      id
      isInitial
    }
  }
`);
